/**
 * The pages of the docs, in the order a reader goes through them. The sidebar shows them by
 * group, and each page links to the one before it and the one after it.
 *
 * The first group is about Morcast as a whole, the second about the Morcast Payment Protocol (the
 * escrow and the open rules that pay a result), and the third about what comes after V1.
 */

/** A page of the docs. */
export interface DocLink {
  to: string;
  label: string;
}

/** The docs' pages by group, in reading order. */
export const DOC_GROUPS: { title: string; pages: DocLink[] }[] = [
  {
    title: "Morcast",
    pages: [
      { to: "/docs", label: "Overview" },
      { to: "/docs/business-model", label: "Business model" },
      { to: "/docs/trust", label: "Trust" },
    ],
  },
  {
    title: "Protocol",
    pages: [
      { to: "/docs/protocol", label: "How it works" },
      { to: "/docs/verification", label: "Verification" },
      { to: "/docs/results", label: "Results and proofs" },
    ],
  },
  {
    title: "Roadmap",
    pages: [{ to: "/docs/roadmap", label: "MOR utility" }],
  },
];

/** Every page of the docs in reading order. */
export const DOC_PAGES: DocLink[] = DOC_GROUPS.flatMap((group) => group.pages);

/** The public protocol, which anyone can use to check Morcast's results. */
export const PROTOCOL_URL = "https://github.com/Morphora-Lab/morcast-protocol";
